import { render, staticRenderFns } from "./VideoCateAddPage.vue?vue&type=template&id=536616a2&scoped=true&"
import script from "./VideoCateAddPage.vue?vue&type=script&lang=js&"
export * from "./VideoCateAddPage.vue?vue&type=script&lang=js&"
import style0 from "./VideoCateAddPage.vue?vue&type=style&index=0&id=536616a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536616a2",
  null
  
)

export default component.exports